export const initializePersistObject = (): void => {
    const existingDataString: string | null = localStorage.getItem('iAuto');

    if (!existingDataString) {
        const initialData: object = {};
        localStorage.setItem('iAuto', JSON.stringify(initialData));
    }
};
